import React from 'react';
import styled from 'styled-components';
import type { Tone } from '@kardume/types';

const toneColor = (tone: Tone, theme: import('styled-components').DefaultTheme) => {
  const map: Record<Tone, string> = {
    primary: theme.primary,
    success: theme.success,
    warning: theme.warning,
    danger: theme.error,
    info: theme.info,
    secondary: theme.mediumGray,
  };
  return map[tone];
};

const Pill = styled.span<{ $tone: Tone }>`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.6rem;
  border-radius: ${(p) => p.theme.radius};
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${(p) => toneColor(p.$tone, p.theme)};
  background: ${(p) => toneColor(p.$tone, p.theme)}1a;
`;

export const Badge: React.FC<{ tone?: Tone; children: React.ReactNode; className?: string }> = ({
  tone = 'secondary',
  children,
  className,
}) => (
  <Pill $tone={tone} className={className}>
    {children}
  </Pill>
);

export default Badge;
